"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BeforeConnectingTelemetry = /** @class */ (function () {
    function BeforeConnectingTelemetry(sendEventFn) {
        var _this = this;
        this.sendEventFn = sendEventFn;
        this.Open = function () { return _this.send('BeforeConnectingDialog_Open'); };
        this.Cancel = function (openDuration) { return _this.send('BeforeConnectingDialog_Cancel', {
            OpenDuration: openDuration
        }); };
        this.ContinueSignIn = function (openDuration) { return _this.send('BeforeConnectingDialog_ContinueSignIn', {
            OpenDuration: openDuration
        }); };
        this.ContinueNoSignIn = function (openDuration) { return _this.send('BeforeConnectingDialog_ContinueNoSignIn', {
            OpenDuration: openDuration
        }); };
    }
    /* tslint:disable-next-line */
    BeforeConnectingTelemetry.prototype.send = function (eventType, eventProperties) {
        if (!this.sendEventFn) {
            return;
        }
        if (!eventProperties) {
            this.sendEventFn(eventType, []);
        }
        else {
            this.sendEventFn(eventType, this.convertToNameValuePairList(eventProperties));
        }
    };
    /* tslint:disable-next-line:no-any */
    BeforeConnectingTelemetry.prototype.convertToNameValuePairList = function (properties) {
        /* tslint:disable-next-line:no-any */
        var nameValuePairList = [];
        Object.keys(properties).forEach(function (key) {
            nameValuePairList.push(key, properties[key]);
        });
        return nameValuePairList;
    };
    return BeforeConnectingTelemetry;
}());
exports.BeforeConnectingTelemetry = BeforeConnectingTelemetry;
//# sourceMappingURL=BeforeConnectingTelemetry.js.map